import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { Spinner, Alert } from "react-bootstrap";
import { apiUrl } from "../coreservices/environment";

function MultiSlideImage() {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const API_URL = 'http://localhost:5000';


    const fetchImages = async () => {
        try {
            setLoading(true);
            setError(null);

            // Option 1: Use axios.get
            const response = await axios.get(`${apiUrl}/imageslidermaster/active`);

            console.log('API Response:', response); // Debug log

            // Check if response has data in the expected format
            if (response.data && response.data.success && response.data.data) {
                setImages(response.data.data);
            } else if (Array.isArray(response.data)) {
                // If response.data is directly an array
                setImages(response.data);
            } else {
                setError("Invalid response format from server");
                setImages([]);
            }

        } catch (error) {
            console.error("Error fetching images:", error);
            setError(`Failed to load images: ${error.message}`);
            setImages([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        rtl: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    // Optional: Add retry button
    const handleRetry = () => {
        fetchImages();
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Loading images...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-5">
                <Alert variant="danger">
                    <Alert.Heading>Error</Alert.Heading>
                    <p>{error}</p>
                    <button
                        className="btn btn-primary mt-2"
                        onClick={handleRetry}
                    >
                        Try Again
                    </button>
                </Alert>
            </div>
        );
    }

    if (!Array.isArray(images) || images.length === 0) {
        return (
            <div className="text-center py-5">
                <Alert variant="info">
                    <Alert.Heading>No Images Available</Alert.Heading>
                    <p>Please add images from the admin panel.</p>
                </Alert>
            </div>
        );
    }

    return (
        <div className="slider-container p-4 bg-gray-100 min-h-screen flex items-center justify-center">
            <div className="w-full max-w-6xl">
                <h2 className="text-2xl font-bold text-center text-blue-600 mb-6">
                    Success Stories
                </h2>

                {/* Debug info - remove in production */}
                <div className="text-center mb-3 text-sm text-gray-500">
                    Showing {images.length} images
                </div>

                <Slider {...settings}>
                    {images.map((image) => (
                        <div key={image._id || image.id} className="p-4">
                            {image.link ? (
                                <a href={image.link} target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={`${apiUrl}${image.imagePath}`}
                                        alt={image.altText || image.title || 'Success Story'}
                                        style={{
                                            width: "300px",
                                            height: "300px",
                                            objectFit: "cover",
                                            borderRadius: "10px",
                                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                            cursor: image.link ? "pointer" : "default"
                                        }}
                                        title={image.title}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = 'https://via.placeholder.com/300x300?text=Image+Not+Found';
                                        }}
                                    />
                                </a>
                            ) : (
                                <img
                                    src={`${apiUrl}${image.imagePath}`}
                                    alt={image.altText || image.title || 'Success Story'}
                                    style={{
                                        width: "300px",
                                        height: "300px",
                                        objectFit: "cover",
                                        borderRadius: "10px",
                                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                    }}
                                    title={image.title}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://via.placeholder.com/300x300?text=Image+Not+Found';
                                    }}
                                />
                            )}
                            {(image.title || image.description) && (
                                <div className="mt-2 text-center" style={{ width: "300px" }}>
                                    {image.title && (
                                        <h6 className="font-semibold">{image.title}</h6>
                                    )}
                                    {image.description && (
                                        <p className="text-sm text-gray-600">{image.description}</p>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default MultiSlideImage;

// import React, { useEffect, useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import axios from "axios";
// import { Spinner, Alert } from "react-bootstrap";

// function MultiSlideImage() {
//     const [images, setImages] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const API_URL = 'http://localhost:5000';

//     const fetchImages = async () => {
//         try {
//             setLoading(true);
//             setError(null);
//             const response = await axios.get(`${API_URL}/imageslidermaster/active`);
//             setImages(response.data);
//         } catch (error) {
//             setError("Failed to load images");
//             console.error("Error fetching images:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchImages();
//     }, []);

//     const settings = {
//         dots: true,
//         infinite: true,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         speed: 500,
//         rtl: false,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                 }
//             },
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                 }
//             }
//         ]
//     };

//     if (loading) {
//         return (
//             <div className="text-center py-5">
//                 <Spinner animation="border" variant="primary" />
//                 <p className="mt-3">Loading images...</p>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <div className="text-center py-5">
//                 <Alert variant="danger">{error}</Alert>
//             </div>
//         );
//     }

//     if (images.length === 0) {
//         return (
//             <div className="text-center py-5">
//                 <Alert variant="info">No images available. Please add images from the admin panel.</Alert>
//             </div>
//         );
//     }

//     return (
//         <div className="slider-container p-4 bg-gray-100 min-h-screen flex items-center justify-center">
//             <div className="w-full max-w-6xl">
//                 <h2 className="text-2xl font-bold text-center text-blue-600 mb-6">
//                     Success Stories
//                 </h2>
//                 <Slider {...settings}>
//                     {images?.map((image) => (
//                         <div key={image._id} className="p-4">
//                             {image.link ? (
//                                 <a href={image.link} target="_blank" rel="noopener noreferrer">
//                                     <img
//                                         src={`${API_URL}${image.imagePath}`}
//                                         alt={image.altText || image.title}
//                                         style={{
//                                             width: "300px",
//                                             height: "300px",
//                                             objectFit: "cover",
//                                             borderRadius: "10px",
//                                             boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
//                                             cursor: image.link ? "pointer" : "default"
//                                         }}
//                                         title={image.title}
//                                     />
//                                 </a>
//                             ) : (
//                                 <img
//                                     src={`${API_URL}${image.imagePath}`}
//                                     alt={image.altText || image.title}
//                                     style={{
//                                         width: "300px",
//                                         height: "300px",
//                                         objectFit: "cover",
//                                         borderRadius: "10px",
//                                         boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
//                                     }}
//                                     title={image.title}
//                                 />
//                             )}
//                             {(image.title || image.description) && (
//                                 <div className="mt-2 text-center">
//                                     {image.title && (
//                                         <h6 className="font-semibold">{image.title}</h6>
//                                     )}
//                                     {image.description && (
//                                         <p className="text-sm text-gray-600">{image.description}</p>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     ))}
//                 </Slider>
//             </div>
//         </div>
//     );
// }

// export default MultiSlideImage;



// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import april from "../assets/testimoney/april.jpeg";
// import dec from "../assets/testimoney/dec.jpeg";
// import feb from "../assets/testimoney/feb.jpeg";
// import jan from "../assets/testimoney/jan.jpeg";
// import july from "../assets/testimoney/july.jpeg";
// import june from "../assets/testimoney/june.jpeg";
// import march from "../assets/testimoney/March.jpeg";
// import may from "../assets/testimoney/MAy.jpeg";
// import nov from "../assets/testimoney/NOv.jpeg";
// import oct from "../assets/testimoney/oct.jpeg";
// import sept from "../assets/testimoney/sept.jpeg";

// // Example image URLs for demonstration
// const images = [april, dec, feb, jan, july, june, march, may, nov, oct, sept];

// function MultiSlideImage() {
//     const settings = {
//         dots: true,
//         infinite: true,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 2000,
//         rtl: true
//     };

//     return (
//         <div className="slider-container p-4 bg-gray-100 min-h-screen flex items-center justify-center">
//             <div className="w-full max-w-4xl">
//                 <h2 className="text-2xl font-bold text-center text-blue-600 mb-6">
//                     Success stories
//                 </h2>
//                 <Slider {...settings}>
//                     {images.map((image, index) => (
//                         <div key={index} className="p-4">
//                             {/* <img
//                                 src={image}
//                                 alt={`Slide ${index + 1}`}
//                                 className="h-100 w-100 object-cover rounded-xl shadow-md"
//                             /> */}

//                             <img
//                                 src={image}
//                                 alt={`Slide ${index + 1}`}
//                                 style={{ width: "300px", height: "300px", objectFit: "cover", borderRadius: "10px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}
//                             />
//                         </div>
//                     ))}
//                 </Slider>
//             </div>
//         </div>
//     );
// }

// export default MultiSlideImage;
